import React from "react";
import { StyleSheet } from "react-native";
import { Text } from "native-base";

import PressableWrapp from "../../../../../../Universal/Buttons/PressableReact/PressableWrapp";
import { useAppContext } from "../../../../../../Universal/API/Context-API/AppContext";
import { webFont } from "../../../../../../Universal/API/API";

type FilterChipProps = {
  label: string;
  active: boolean;
  disabled?: boolean;
  onPress: () => void;
};

const FilterChip: React.FC<FilterChipProps> = ({
  label,
  active,
  disabled = false,
  onPress,
}) => {
  const { scaleAll } = useAppContext();
  const styles = React.useMemo(() => createStyles(scaleAll), [scaleAll]);

  return (
    <PressableWrapp
      onPress={disabled ? undefined : onPress}
      activeOpacity={disabled ? 1 : 0.86}
      disabled={disabled}
      style={[
        styles.chip,
        active ? styles.chipActive : null,
        disabled ? styles.chipDisabled : null,
      ]}
    >
      <Text
          selectable={false}
          style={[
            styles.text,
            active ? styles.textActive : null,
            disabled ? styles.textDisabled : null,
          ]}
        >
          {label}
        </Text>
    </PressableWrapp>
  );
};

const createStyles = (scaleAll: number) =>
  StyleSheet.create({
    chip: {
      minHeight: 38 * scaleAll,
      borderRadius: 999,
      paddingHorizontal: 12 * scaleAll,
      paddingVertical: 7 * scaleAll,
      borderWidth: 1,
      borderColor: "#E7E1D8",
      backgroundColor: "#FFFFFF",
      alignItems: "center",
      justifyContent: "center",
    },
    chipActive: {
      backgroundColor: "#111111",
      borderColor: "#111111",
    },
    chipDisabled: {
      backgroundColor: "#F4F1EB",
      borderColor: "#ECE8E1",
      opacity: 0.6,
    },
    text: {
      fontFamily: webFont("Inter"),
      fontSize: 12 * scaleAll,
      color: "#3C3732",
      fontWeight: "600",
    },
    textActive: {
      color: "#FFFFFF",
    },
    textDisabled: {
      color: "#8C857C",
    },
  });

export default React.memo(FilterChip);
